const startedUrls = new Set();

/**
 * Starts downloading pictures before they are shown (the agent menu's, which only renders when it
 * opens), so they come from the browser's cache when they appear. Each URL is fetched once per page.
 */
export const preloadImages = (urls) => {
  urls.forEach((url) => {
    if (!url || startedUrls.has(url)) {
      return;
    }
    startedUrls.add(url);
    const image = new Image();
    image.decoding = "async";
    image.src = url;
  });
};
